import { render, staticRenderFns } from "./restore-confirmation-modal.vue?vue&type=template&id=f03ded44&scoped=true"
import script from "./restore-confirmation-modal.vue?vue&type=script&lang=js"
export * from "./restore-confirmation-modal.vue?vue&type=script&lang=js"
import style0 from "./restore-confirmation-modal.vue?vue&type=style&index=0&id=f03ded44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03ded44",
  null
  
)

export default component.exports